import React, { useState, useEffect, useMemo } from 'react';
import { Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { postService, contentCategoryService } from '../../../services/cms/contentManagementService';

const { Text } = Typography;

const STATUS_OPTIONS = [
  { label: 'Duyệt', value: 1 }, { label: 'Xóa', value: 0 }, { label: 'Đợi duyệt', value: 2 },
  { label: 'Lưu lại', value: 3 }, { label: 'Trả lại', value: 4 }, { label: 'Đã duyệt', value: 6 },
];

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  { title: 'TIÊU ĐỀ', dataIndex: 'title', key: 'title', render: (t) => <Text strong>{t}</Text> },
  { title: 'ẢNH', dataIndex: 'image_url', key: 'image_url', width: 80, render: (u) => u ? <img src={u} alt="" style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }} /> : '-' },
  { title: 'TÁC GIẢ', dataIndex: 'author', key: 'author', width: 120 },
  { title: 'NGƯỜI TẠO', dataIndex: 'author_name', key: 'author_name', width: 130, render: (val, r) => val || r.create_by || r.created_by || '-' },
  { title: 'DANH MỤC', dataIndex: 'category_id', key: 'category_id', width: 150, render: (id, r) => r.category_name ? `[${id}] ${r.category_name}` : (id || '--') },
  { title: 'TRẠNG THÁI', dataIndex: 'status', key: 'status', width: 110, render: (s) => { const map = { 0: ['red','XÓA'], 1: ['green','DUYỆT'], 2: ['orange','ĐỢI DUYỆT'], 3: ['blue','LƯU LẠI'], 4: ['purple','TRẢ LẠI'], 6: ['cyan','ĐÃ DUYỆT'] }; const [c,l] = map[s] || ['default', s]; return <Tag color={c}>{l}</Tag>; } },
  { title: 'NGÀY PHÁT HÀNH', dataIndex: 'publish_date', key: 'publish_date', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
  { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const QuanLyBaiVietND = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    contentCategoryService.listActive().then((res) => {
      if (Array.isArray(res)) {
        setCategories(res.map((c) => ({ label: `[${c.id}] ${c.title}`, value: c.id })));
      }
    });
  }, []);

  const formFields = useMemo(() => [
    { name: 'title', label: 'Tiêu đề', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập tiêu đề!' }] },
    { name: 'category_id', label: 'Danh mục', type: 'select', options: categories, propsInput: { showSearch: true } },
    { name: 'author', label: 'Tác giả', type: 'input' },
    { name: 'description', label: 'Mô tả ngắn', type: 'textarea', propsInput: { rows: 3 } },
    { name: 'content', label: 'Nội dung', type: 'ckeditor' },
    { name: 'image_url', label: 'Ảnh đại diện', type: 'upload-cdn' },
    { name: 'tags', label: 'Tags', type: 'input', placeholder: 'tag1, tag2, ...' },
    // CMS cũ: "Thứ tự" chính là cột posts.place — int(11). Phải là InputNumber, không dùng
    // input chữ (gõ 'e' là 500 `Incorrect integer value`, QA-04) cũng không dùng
    // <input type="number"> HTML vì thẻ đó vẫn nhận 'e', '+', '-' của ký hiệu khoa học.
    { name: 'place', label: 'Thứ tự', type: 'number', placeholder: 'thứ tự', propsInput: { precision: 0 } },
    // Giống CMS cũ (fixDate): chỉ lưu ngày, không giờ — để filter Ngày phát hành so `=` khớp được
    { name: 'publish_date', label: 'Ngày phát hành', type: 'date', format: 'DD/MM/YYYY', submitFormat: 'YYYY-MM-DD' },
    { name: 'metadata', label: 'Metadata (JSON)', type: 'textarea', propsInput: { rows: 2 } },
    { name: 'status', label: 'Trạng thái', type: 'select', options: STATUS_OPTIONS, defaultValue: 1 },
  ], [categories]);

  const filterFields = useMemo(() => [
    {
      label: 'Chọn danh mục',
      value: 'category_id',
      options: [{ label: 'Tất cả danh mục', value: '' }, ...categories],
    },
    {
      label: 'Trạng thái',
      value: 'status',
      options: [
        { label: 'Tất cả trạng thái', value: '' },
        { label: 'Duyệt', value: 1 },
        { label: 'Đợi duyệt', value: 2 },
      ],
    },
    {
      label: 'Ngày phát hành',
      value: 'publish_date',
      type: 'date',
      // Giống CMS cũ: publish_date = 'YYYY-MM-DD'
      submitFormat: 'YYYY-MM-DD',
    },
  ], [categories]);

  return (
    <CrudPage
      title="QUẢN LÝ BÀI VIẾT"
      subTitle="Quản lý bài viết nội dung hệ thống"
      itemsName="Bài viết"
      queryKey="postList"
      service={postService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm theo tiêu đề..."
      addButtonLabel="Thêm bài viết"
      formConfig={{ width: 1000 }}
    />
  );
};

export default QuanLyBaiVietND;
